
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import ProductDetails from '@components/organisms/ProductDetails';
import { createSwrCmsLayoutFallback, defaultRevalidationInterval } from '@helpers/fallback';
const ProductPage = () => {
    return <ProductDetails isPage/>;
};
export default ProductPage;
export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking',
    };
}
const getStaticProps = async () => {
    const fallback = createSwrCmsLayoutFallback();
    return {
        props: {
            fallback,
        },
        revalidate: defaultRevalidationInterval,
    };
};

    async function __Next_Translate__getStaticProps__19ae8534dde__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/productDetail/[name]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19ae8534dde__ as getStaticProps }
  